import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grow,
  Modal,
  styled,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import "./actionModalStyle.css";
import { getIcon } from "../../../../utils/iconConfig";
import PhoneInput from "react-phone-input-2";
import { ReactComponent as Flag } from "../../../../assets/icons/client_icon/flag.svg";
import apiClient from "../../../../lib/api_client";
import { QueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import CustomToast from "../../CustomToast";

const ActionModal = ({
  openModal,
  handleClose,
  data,
  selectAction,
  refetch,
  setLoader,
}) => {
  const [Emails, setEmails] = useState([]);
  const [emailInput, setEmailInput] = useState([]);
  const [emailShowField, setEmailShowField] = useState(false);

  const [mobileNumbers, setMobileNumbers] = useState([]);
  const [mobileInput, setmobileInput] = useState([]);
  const [mobileShowField, setMobileShowField] = useState(false);
  const [selectedMobileNumbers, setSelectedMobileNumbers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const phoneRefs = useRef([]);

  let formattedMobileNumbers = data?.matchClientMobileNumber?.whatsAppNos.map((str) => {
    if (str.length === 10) return str;
    return str.slice(2);
  });

  const handlemailInput = (e, index) => {
    const updatedInputs = [...emailInput];
    updatedInputs[index] = e.target.value;
    setEmailInput(updatedInputs);
  };

  const handleMobileInput = (value, index) => {
    const updatedMobiles = [...mobileInput];
    // const phoneDigits = value.replace(/^91/, "").replace(/\D/g, "");
    const phoneDigits = value;
    updatedMobiles[index] = phoneDigits;
    setmobileInput(updatedMobiles);
  };

  const handleAddNewEmailInput = () => {
    if (!emailShowField) {
      setEmailShowField(true);
      setEmailInput(Emails.length > 0 ? Emails : [""]);
    } else {
      setEmailInput((prev) => [...prev, ""]);
    }
  };

  const handleDeleteEmailInput = (index) => {
    if (emailInput.length <= 1) {
      const updatedEmails = [...emailInput];
      updatedEmails[index] = "";
      setEmailInput(updatedEmails);
      return;
    }
    setEmailInput((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDeletePhoneInput = (index) => {
    if (mobileInput.length <= 1) {
      const updatedMobiles = [...mobileInput];
      updatedMobiles[index] = "";
      setmobileInput(updatedMobiles);
      setMobileShowField(false);
      return;
    }
    setmobileInput((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddNewMobileInput = () => {
    if (!mobileShowField) {
      setMobileShowField(true);
      // setmobileInput(
      //   mobileNumbers.length > 0 ? [...mobileNumbers, ""] : ["", ""]
      // );
      setmobileInput(mobileNumbers.length > 0 ? [...data?.matchClientMobileNumber?.whatsAppNos, ""] : ["", ""]);
    } else {
      setmobileInput((prev) => [...prev, ""]);
    }
  };

  const handleModalClose = () => {
    handleClose();
    setEmails([]);
    setEmailShowField(false);
    setEmailInput([]);
    setMobileNumbers([]);
    setMobileShowField(false);
    setmobileInput([]);
  };

  const isValidMobile = (num) => /^[6-9]\d{9}$/.test(num);
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const handleSave = async () => {
    setIsLoading(true);

    try {
      const invalidMobiles = [];
      const validMobiles = mobileInput.filter((num) => {
        let exactNumber;
        if (num.includes("+91")) {
          exactNumber = num.slice(4);
        } else {
          exactNumber = num.slice(2);
        }

        const valid = isValidMobile(exactNumber);

        if (!valid && num) invalidMobiles.push(num);
        return valid;
      });

      const invalidEmails = [];
      const validEmails = emailInput.filter((email) => {
        const valid = isValidEmail(email);
        if (!valid && email) invalidEmails.push(email);
        return valid;
      });

      // ❌ Stop if there are any invalid inputs
      if (invalidMobiles.length > 0) {
        toast.error("Some Moible Numbers are invalid. Please correct them.");
        return;
      }
      if (invalidEmails.length > 0) {
        toast.error("Some Emails are invalid. Please correct them.");
        return;
      }

      if (selectAction === "whatsapp" && validMobiles.length === 0) {
        toast.error("Please enter at least one valid 10-digit mobile number");
        setIsLoading(false);
        return;
      }
      if (selectAction === "email" && validEmails.length === 0) {
        toast.error("Please enter at least one valid email address");
        setIsLoading(false);
        return;
      }
      const payload = {
        clientName: data?.clientName,
        partyNo: data?.partyNo,
        partyCode: data?.partyCode,
        // whatsAppNos:
        //   selectAction === "whatsapp"
        //     ? mobileInput
        //         .filter((num) => num && num.length === 10)
        //         .map((num) => num.replace(/^91/, ""))
        //     : data?.matchClientMobileNumber?.whatsAppNos || [],
        whatsAppNos:
          selectAction === "whatsapp"
            ? validMobiles
            : data?.matchClientMobileNumber?.whatsAppNos || [],
        emails:
          selectAction === "emails"
            ? validEmails
            : data?.matchClientMobileNumber?.emails || [],
      };

      if (selectAction === "whatsapp" && payload.whatsAppNos.length === 0) {
        alert("Please enter at least one valid 10-digit phone number");
        return;
      }

      await apiClient.post("/addNewClientWithMobileEmail", payload);

      if (selectAction === "emails") {
        setEmailShowField(false);
        setEmails(validEmails);
      } else {
        setMobileShowField(false);
        setMobileNumbers(validMobiles);
      }

      toast?.custom((t) => (
        <CustomToast
          t={t}
          message={
            selectAction === "emails"
              ? `Emails Updated Successfully`
              : `Numbers Updated Successfully`
          }
        />
      ));

      refetch();
      handleModalClose();
    } catch (error) {
      toast?.custom((t) => (
        <CustomToast
          t={t}
          isError={true}
          message={
            selectAction === "emails"
              ? `Failed to Update Emails`
              : `Failed to Update Numbers`
          }
        />
      ));
    } finally {
      setIsLoading(false);
    }
  };

  const handleWhatsappSubmit = async () => {
    setLoader(true);

    const formattedNumbers = selectedMobileNumbers.map((num) => {
      let cleanedNum = num.replace(/\D/g, "");
      if (cleanedNum.length > 11) {
        return cleanedNum;
      }
      return `91${cleanedNum}`;
    });

    let payload = {
      gatiOrderId: data?.gatiOrderId,
      mobileNumbers: formattedNumbers,
    };

    try {
      const response = await apiClient.post(`/sendWhatsAppInvoice`, payload);

      if (response?.status === 200) {
        setLoader(false);
        setSelectedMobileNumbers([]);
        toast?.custom((t) => (
          <CustomToast
            t={t}
            message={`Order Details Send Successfully On MobileNumbers`}
          />
        ));
      }
      handleClose();
    } catch (error) {
      setLoader(false);
      toast?.custom((t) => (
        <CustomToast
          t={t}
          isError={true}
          message={`There was a problem sending Order Details`}
        />
      ));
      handleClose();
    }
  };

  const StyledButton = styled(Button)(({ theme }) => ({
    minWidth: "17.8vw",
    minHeight: "2vw",
    backgroundColor: "#50C878",
    borderRadius: ".4vw",
    padding: ".45vw 2vw",
    color: "#000000",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: ".7vw",
    lineHeight: "100%",
  }));

  const StyledCheckbox = styled(Checkbox)({
    width: "1vw",
    height: "1vw",
    borderRadius: ".3vw",
    border: "0.05vw solid black",
    padding: ".05vw",
    "& svg": {
      display: "none",
    },
    "&:before": {
      content: '"\\2714"',
      color: "white",
      fontSize: ".6vw",
    },
    "&.Mui-checked": {
      backgroundColor: "#50C878",
      border: "0.05vw solid black",
    },
    "&.Mui-focusVisible": {
      outline: "none",
      boxShadow: "none",
    },
  });

  let modalContent;

  switch (selectAction) {
    case "emails":
      modalContent = (
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          gap=".8vw"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography className="modal-title">
              {emailShowField ? "Add Email" : "Select Email"}
            </Typography>
            <div className="close-section">
              <button
                className="addField"
                onClick={() => handleAddNewEmailInput()}
              >
                Email +
              </button>
              <Typography
                className="modal-close"
                sx={{ display: emailShowField ? "none" : "flex" }}
                onClick={() => handleModalClose()}
              >
                {getIcon("Cross")}
              </Typography>
            </div>
          </Box>

          {emailShowField ? (
            <>
              <div className="fixed-modal-height">
                {emailInput.map((email, index) => (
                  <div key={index} className="input-section">
                    <input
                      type="email"
                      value={email}
                      placeholder="Enter the Email"
                      onChange={(e) => handlemailInput(e, index)}
                    />
                    {email?.includes(".com") && (
                      <button onClick={() => handleDeleteEmailInput(index)}>
                        {getIcon("dustbin")}
                      </button>
                    )}
                  </div>
                ))}
              </div>
              <div className="footer-btn-grp">
                <button
                  className="btn-1"
                  onClick={() => {
                    setEmailShowField(false);
                    setEmailInput([]);
                  }}
                  disabled={isLoading}
                >
                  cancel
                </button>
                <button
                  className="btn-2"
                  onClick={handleSave}
                  disabled={isLoading}
                >
                  {isLoading ? "Saving..." : "save"}
                </button>
              </div>
            </>
          ) : (
            <>
              {Emails.map((item, index) => (
                <FormControlLabel
                  key={index}
                  name={item}
                  control={<StyledCheckbox />}
                  labelPlacement="start"
                  label={<Typography className="modal-data">{item}</Typography>}
                  className="action-modal-label"
                />
              ))}
              <StyledButton onClick={handleClose}>Send Email</StyledButton>
            </>
          )}
        </Box>
      );
      break;

    case "whatsapp":
      modalContent = (
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          gap=".8vw"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography className="modal-title">
              {mobileShowField ? "Add Mobile No." : "Select Mobile No."}
            </Typography>
            <div className="close-section">
              <button
                className="addField"
                onClick={() => handleAddNewMobileInput()}
              >
                Mobile +
              </button>
              <Typography
                className="modal-close"
                sx={{ display: mobileShowField ? "none" : "flex" }}
                onClick={() => handleModalClose()}
              >
                {getIcon("Cross")}
              </Typography>
            </div>
          </Box>
          {mobileShowField ? (
            <>
              <div className="fixed-modal-height">
                {mobileInput.map((mobile, index) => (
                  <div key={index} className="input-section">
                    <div className="phone-wrapper">
                      <span>
                        <Flag />
                      </span>
                      <div className="phone-box">
                        <PhoneInput
                          country={"in"}
                          disableDropdown={true}
                          countryCodeEditable={false}
                          placeholder=""
                          // value={mobile ? `+91${mobile}` : "+91"}
                          value={mobile && mobile?.startsWith("91") ? `+${mobile}` : `+91 ${mobile}`}
                          onChange={(value) => handleMobileInput(value, index)}
                          inputProps={{
                            ref: (el) => (phoneRefs.current[index] = el),
                          }}
                        />
                        {!mobile && (
                          <span
                            onClick={() => phoneRefs.current[index]?.focus()}
                            className="placeHolder"
                          >
                            Enter your phone No.
                          </span>
                        )}
                      </div>
                    </div>
                    {/* Show delete button for all fields except when it's the only empty field */}
                    {(mobileInput?.length > 1 || mobile) && (
                      <button onClick={() => handleDeletePhoneInput(index)}>
                        {getIcon("dustbin")}
                      </button>
                    )}
                  </div>
                ))}
              </div>
              <div className="footer-btn-grp">
                <button
                  className="btn-1"
                  onClick={() => {
                    setMobileShowField(false);
                    setmobileInput([]);
                  }}
                  disabled={isLoading}
                >
                  cancel
                </button>
                <button
                  className="btn-2"
                  onClick={handleSave}
                  disabled={isLoading}
                >
                  {isLoading ? "Saving..." : "save"}
                </button>
              </div>
            </>
          ) : (
            <>
              {mobileNumbers?.map((item, index) => (
                <FormControlLabel
                  key={index}
                  name={item}
                  control={<StyledCheckbox />}
                  checked={selectedMobileNumbers.includes(item)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedMobileNumbers((prev) => [...prev, item]);
                    } else {
                      setSelectedMobileNumbers((prev) =>
                        prev.filter((num) => num !== item)
                      );
                    }
                  }}
                  labelPlacement="start"
                  label={<Typography className="modal-data">{`+91 ${item}`}</Typography>}
                  className="action-modal-label"
                />
              ))}
              <StyledButton onClick={handleWhatsappSubmit}>
                Send Whatsapp
              </StyledButton>
            </>
          )}
        </Box>
      );
      break;

    default:
      modalContent = <></>;
  }

  useEffect(() => {
    if (selectAction === "emails") {
      setEmails(data?.matchClientMobileNumber?.emails || []);
    } else if (selectAction === "whatsapp") {
      setMobileNumbers(formattedMobileNumbers || []);
    }
  }, [selectAction, data]);

  useEffect(() => {
    phoneRefs.current = phoneRefs.current.slice(0, mobileInput.length);
  }, [mobileInput.length]);

  return (
    <Modal
      open={openModal}
      onClose={handleModalClose}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Grow in={openModal}>
        <Box
          sx={{
            position: "absolute",
            top: "40%",
            bgcolor: "white",
            borderRadius: ".6vw",
            p: ".75vw",
            outline: "none",
            border: "none",
            minWidth: "1.4vw",
            marginX: "auto",
          }}
        >
          {modalContent}
        </Box>
      </Grow>
    </Modal>
  );
};

export default ActionModal;
